import { render, staticRenderFns } from "./TeacherWorkListUnitWrap.vue?vue&type=template&id=3e5ed802&scoped=true"
import script from "./TeacherWorkListUnitWrap.vue?vue&type=script&lang=js"
export * from "./TeacherWorkListUnitWrap.vue?vue&type=script&lang=js"
import style0 from "./TeacherWorkListUnitWrap.vue?vue&type=style&index=0&id=3e5ed802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ed802",
  null
  
)

export default component.exports